import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export type OrgMatterSummary = {
  id: string;
  name: string;
};

export const useFetchOrgMatters = (orgId: string = '') => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<OrgMatterSummary[]>(
    ['fetchOrgMatters', orgId],
    () => {
      const queryParams = new URLSearchParams({ orgId }).toString();
      return fetch(`${APIBaseChronos}/api/org/matters?${queryParams}`, fetchConfigGET)
        .then((res) => res.json())
        .catch((err) => {
          console.error(err);
        });
    },
    {
      cacheTime: 0,
      enabled: true,
    },
  );
};
